// === FILE: assets/italiansecret-cart-stock-core.js ===
// Core logic for ItalianSecret Cart Stock Check
// Depends on utils.js (must be loaded BEFORE this file)
//
// Functions:
// - getInventoryBySku()
// - buildRequirements()
// - validateInventory()
// -------------------------------------------------------------------

window.inventoryCache = {};

// 🔧 Fetch stock quantity from stockMap or fallback
window.getInventoryBySku = async function(rawSku) {
  let sku = rawSku;
  if (!sku) return 0;

  // Convert GID → SKU if needed
  if (sku.startsWith("gid://")) {
    sku = gidToSku(sku);
  }

  // Cached?
  if (Object.prototype.hasOwnProperty.call(inventoryCache, sku)) {
    return inventoryCache[sku];
  }

  // Found in stock map
  if (Object.prototype.hasOwnProperty.call(stockMap, sku)) {
    const qty = Number(stockMap[sku] ?? 0);
    inventoryCache[sku] = qty;
    return qty;
  }

  console.warn(`${IS_LOG_PREFIX} – No stock entry for ${sku}, treating as UNTRACKED.`);
  inventoryCache[sku] = null; // null = untracked (won’t block)
  return null;
};

// 🧮 Build total ingredient requirements for the cart
window.buildRequirements = async function() {
  const res = await fetch("/cart.js", { cache: "no-cache" });
  const cart = await res.json();

  console.log(
    `${IS_LOG_PREFIX} – Cart items:`,
    cart.items.map(i => ({
      title: i.product_title,
      sku: i.sku,
      quantity: i.quantity,
    }))
  );

  const required = {};

  for (const item of cart.items) {
    const sku = (item.sku || "").trim();
    const qty = Number(item.quantity) || 0;
    if (!sku || qty <= 0) continue;

    const included = includedMap[sku];
    console.log(`${IS_LOG_PREFIX} – Inspect item`, {
      title: item.product_title,
      sku,
      qty,
      included,
    });

    // PIZZA → add toppings from includedMap
if (Array.isArray(included) && included.length > 0) {
  for (const gid of included) {
    const toppingSku = gidToSku(gid);
    if (!toppingSku || toppingSku.startsWith("gid://")) {
      console.warn(`${IS_LOG_PREFIX} – ⚠️ Could not resolve GID ${gid} to SKU`);
      continue;
    }
    required[toppingSku] = (required[toppingSku] || 0) + qty;
  }
}

    // EXTRA TOPPING → direct SKU (starts with T)
    if (sku.startsWith("T")) {
      required[sku] = (required[sku] || 0) + qty;
    }
  }

  console.log(`${IS_LOG_PREFIX} – Requirements built (SKUs only):`, required);
  return required;
};

// ✅ Validate inventory availability
window.validateInventory = async function() {
  const requirements = await buildRequirements();
  const toppingSkus = Object.keys(requirements);
  if (!toppingSkus.length) {
    console.log(`${IS_LOG_PREFIX} – No shared toppings in cart, skipping check.`);
    return [];
  }

  const availableList = await Promise.all(toppingSkus.map(sku => getInventoryBySku(sku)));
  const shortages = [];

  toppingSkus.forEach((sku, idx) => {
    const needed = requirements[sku];
    const available = availableList[idx];

    if (available === null) return; // untracked
    if (needed > available) {
      shortages.push({ sku, needed, available });
    }
  });

  console.log(`${IS_LOG_PREFIX} – Inventory check complete. Shortages:`, shortages);
  return shortages;
};

console.log(`${IS_LOG_PREFIX} – Core functions loaded successfully ✅`);